import { FormattedMessage } from "react-intl";
import MyModerationsIcon from "../../../components/Common/SvgIcons/SocialIcons/MyModerationsIcon";
import { moderateContributions } from "./moderateContributions";

export const myModerations = {
  label: <FormattedMessage id="MyModuration_Txt" />,
  path: (tenantName) =>
    `${moderateContributions.path(tenantName)}/myModerations`,
  icon: (fill) => <MyModerationsIcon fill={fill} />,
  searchPlaceHolder: "Search my moderations by name",
};
